import { AutocompleteChangeReason } from "@mui/material";
import { ETableEditAction, EWidths } from "./Enums";
import {
  AlertModel,
  Attachment,
  ClientModel,
  ContactModel,
  ConversationModel,
  EmailTemplateModel,
  LogModel,
  MessageModel,
  NoteModel,
  OblioBillingDocument,
  OrderLineModel,
  OrderModel,
  ProductModel,
  TaskStatusModel,
  UserModel,
  WhatsAppBusinessAccountData,
} from "./Models";
import { ReactNode } from "react";
import {
  Control,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";

/* eslint-disable no-unused-vars */
export enum FgoClientType {
  PF = "PF",
  PJ = "PJ",
}

export enum FgoCurrency {
  RON = "RON",
  EUR = "EUR",
  USD = "USD",
}
/* eslint-enable no-unused-vars */

export type Role = {
  name: string;
  priority: string | number;
  createdAt: string;
  updatedAt: string;
  _id: string;
};

export type Address = {
  city: string;
  county: string;
  country: string;
  details: string;
  _id: string;
};

export type Response = {
  status: string | number;
  data: any;
};

export type UserStateProps = {
  _id: string | number;
  firstName: string | number;
  lastName: string | number;
  email: string | number;
  username: string | number;
  roleIds: [Role];
};

export type PaginatedResponse = {
  status: string | number;
  data: {
    results: any[];
    numberOfResults: number;
  };
};

export type TodaysContactsResponse = {
  status: string | number;
  data: {
    noTotalResults: number;
    noTakenContacts: number;
    noAvailableContacts: number;
    noDelayedContacts: number;
  };
};

export type ContactsResumeProps = {
  noTotalResults: number | null;
  noTakenContacts: number | null;
  noAvailableContacts: number | null;
};

export type CustomTabPanelProps = {
  children: React.ReactNode;
  value: any;
  index: any;
};

export type ProductPanelProps = {
  index?: any;
  product?: any;
  reset?: any;
  register?: any;
  control?: any;
  getValues?: any;
  setValue?: any;
  watch?: any;
  disabled?: boolean;
  invoiceGeneration?: boolean;
  products: ProductModel[];
  managements?: any;
};
export type ProductPanelOrderOfferProps = {
  index?: any;
  product?: any;
  reset?: any;
  register?: any;
  control?: any;
  getValues?: any;
  setValue?: any;
  watch?: any;
  disabled?: boolean;
  products: ProductModel[];
  isOrderOffer?: boolean;
};

export type TransportMethodsProps = {
  control?: any;
  getValues?: any;
  setValue?: any;
  disabled?: boolean;
  transportOptions: any;
  error?: boolean;
};

export type ClientPanelProps = {
  reset?: any;
  register?: any;
  getValues?: any;
  setValue?: any;
  control?: any;
  formState?: any;
  watch?: any;
  clearErrors?: any;
  disabled?: boolean;
};

export type ClientPanelOrderOfferProps = {
  reset?: any;
  register?: any;
  getValues?: any;
  setValue?: any;
  control?: any;
  formState?: any;
  watch?: any;
  clearErrors?: any;
};

export type EditProductProps = {
  searchUrl: string;
  onProductChange: (
    e: any,
    value: OrderLineModel | null,
    reason: AutocompleteChangeReason,
    details?: any
  ) => void;
  disabled?: boolean;
  control?: any;
  getValues?: any;
  index?: any;
  setValue?: any;
  watch?: any;
  products: ProductModel[];
  isOrderOffer?: boolean;
};

export type PaymentPanelProps = {
  getValues?: any;
  setValue?: any;
  disabled?: boolean;
  error?: boolean;
  paymentMethods: any[];
  control?: any;
  watch?: any;
};

export type TotalPanelProps = {
  reset?: any;
  register?: any;
  control?: any;
  getValues?: any;
  setValue?: any;
  watch?: any;
  disabled?: boolean;
  isOrderOffer?: boolean;
};

export type ShippingPanelProps = {
  reset?: any;
  register?: any;
  getValues?: any;
  setValue?: any;
  formState?: any;
  watch?: any;
  disabled?: boolean;
  error?: boolean;
};

export type DeleteActionProps = {
  onCancelAction: () => void;
  onDeleteAction: () => void;
};

export type DropzoneComponentProps = {
  onSave: (file: any) => void;
  paths?: any[];
  acceptedFileTypes?: any;
  error?: any;
  altText?: string;
  maxFiles?: number;
  multiple?: boolean;
  maxSize?: number;
};

export type SpecialDividerProps = {
  title?: string;
  button?: any;
};

export type DynamicTabsProps = {
  labels: string[] | Label[];
  tabValue: number;
  handleChange?: (tabIndex: number) => void;
  badge?: any;
  key?: any;
};

export type FileMessageExplorerProps = {
  message: MessageModel;
};

export type Label = {
  label: string;
  badge: number | string;
  tabColor?: string;
};

export type LoginResponseType = {
  status: string | number;
  data: {
    userId: string;
    userName: string;
    access_token: string;
    roles: any[];
    fullName: string;
  };
};

export type ContactWidgetProps = {
  contact: ContactModel;
  key: number;
};

export type StepperNotesProps = {
  notes: Array<any>;
  updateNotes: (notes: Array<any>) => void;
  disabled?: boolean;
};

export type DisplayOneNoteProps = {
  note: any;
  handleEdit: (note: any) => void;
  handleDelete: (note: any) => void;
  disabled?: boolean;
};

export type ContactSummaryProps = {
  onClick: () => void;
  contact: ContactModel;
};

export type CustomDrawerProps = {
  open: boolean;
  handleDrawerClose: () => void;
  title: string;
  children: any;
  formId: string;
  okText?: string;
  cancelText?: string;
  className?: string;
};

export type EditNoteProps = {
  note: NoteModel;
  open: boolean;
  handleClose: () => void;
  setContextValue: (note: any) => void;
  setShouldSubmit: (value: boolean) => void;
  id?: string | null;
};

export type CreateAndUpdateOrderResponse = {
  status: string | number;
  data: OrderModel;
};

export type ContactOrderProps = {
  setContextValue: (contact: ContactModel) => void;
  disabled: boolean;
};

export type GlobalContextType = {
  contactId: string | null;
  setContactId: (value: string | null) => void;
};

export type ContactPhoneProps = {
  handleChange: (property: string, value: string) => void;
  disabled: boolean;
};

export type CustomInfiniteScrollListProps = {
  id?: string | number;
  items: any[];
  render: (item: any, index: number) => JSX.Element;
  listStyle?: any;
  listItemsStyle?: any;
  style?: any;
};

export type ContactModalProps = {
  contactId: string | null | undefined;
  setShouldUpdate: (value: boolean) => void;
  open: boolean;
  setOpen: (value: boolean) => void;
};

export type CustomPanelProps = {
  title: string;
  children: React.ReactNode;
  actionButtons?: any;
  error?: any;
};

export type OrderOfferCustomPanelProps = {
  children: React.ReactNode;
  title: string;
  error?: boolean;
};

export type NoDataFoundProps = {
  classNames?: any;
  text?: string;
};

export type MainSliderProps = {
  name: string;
  data: any;
  setHideSlider?: any;
  isExpanded?: boolean;
};

export type ImportExcelModalProps = {
  headers: string[];
  title: string;
  setLoading?: (loading: boolean) => void;
  openImportModal: boolean;
  setOpenImportModal: (openImportModal: boolean) => void;
  getNewRow: (row: any) => void;
  getRowsAsArrayData: (data: any) => void;
};

export type GenericModalProps = {
  open: boolean;
  onClose: () => void;
  children: any;
  title: string;
  actions?: any;
  style?: any;
  className?: string;
  maxWidth?: EWidths | false;
  otherOptions?: any;
};

export type MUIDataTableCustomStyleProps = {
  title: string;
  columns: any;
  onEditAction:
  | ETableEditAction.MODAL
  | ETableEditAction.REDIRECT
  | ETableEditAction.INLINE
  | ETableEditAction.NONE;
  id?: string | "";
  hideAddButton?: boolean;
  hideOptions?: boolean;
  options?: any;
  buttons?: any | JSX.Element;
  CRUDEndPoint?: string;
  addOrEditForm?: any; //JSX.Element
  setContextValue?: any;
  CRUDContext?: any;
  reloadURL?: any;
  triggerReload?: boolean;
  customTriggerReload?: boolean;
  rowClickURL?: string;
  onRowClick?: (rowData: any) => void;
  handleModalForm?: any;
  handleInlineForm?: any;
  hideDeleteButton?: boolean;
  hideEditButton?: boolean;
  renderCustomColumns?: (rowIndex: number, value: any) => any;
  selectableRows?: any;
  filters?: any;
  addEntityIdToURL?: boolean;
  rowProps?: any;
  customToolbarSelect?: (
    selectedRows: any,
    displayData: any,
    setSelectedRows: any
  ) => any;
  shouldTriggerStorageUpdate?: boolean;
  customRowRender?: (
    row: any,
    dataIndex: number,
    rowIndex: number,
    tableData: any[]
  ) => any;
  viewColumns?: boolean;
  getRowStyle?: (rowData: any) => React.CSSProperties;
};

export type StandardActionButtonsProps = {
  okAction?: () => void;
  cancelAction: () => void;
  okText: string;
  cancelText: string;
  formId?: string;
  type?: "submit" | "button";
};

export type EmailTemplateImagesProps = {
  handleUploadAttachment: (file: any, alt: string) => void;
  id?: any;
};

export type EmailTemplateDeleteImagesProps = {
  emailTemplate: EmailTemplateModel;
  handleDeleteImage: (attachment: Attachment) => void;
  id?: any;
};

export type EditorToolbarCustomButtonProps = {
  children: any;
};

export type ListItemBillingDocProps = {
  doc: OblioBillingDocument;
  handleDeleteBillingDoc: (
    series: string,
    number: string,
    type: string
  ) => void;
  handleCancelBillingDoc: (
    series: string,
    number: string,
    type: string
  ) => void;
  handleIssueInvoiceOnNotice: (doc: OblioBillingDocument) => void;
  handleIssueCollectInvoice: (doc: OblioBillingDocument) => void;
};

export type ListItemProductLineProps = {
  name: string;
  vatPercentage?: string;
  quantity: string;
  priceWithoutTVA: string;
  price: string;
  management: string;
  discount?: string;
  index?: number;
  control?: any;
  managements?: any;
  productType?: string;
};

export type InvoicePanelProps = {
  handleSaveOrder: (order: OrderModel) => void;
  getOrderValues?: any;
  watchOrder?: any;
  managements: any[];
};

export type MainHeaderProps = {
  setIsExpanded: () => void;
  name: string;
  shouldRenderSearchBar?: boolean;
};

export type DashboardPageProps = {
  shouldRenderSearchBar?: boolean;
};

export type PageNotFoundProps = {
  text: string;
};

export type EditClientModalProps = {
  onClientChange: (
    e: any,
    value: ClientModel | null,
    reason: AutocompleteChangeReason,
    details?: any
  ) => void;
  disabled: boolean;
  control?: any;
  getValues?: any;
  formState?: any;
  setValue?: any;
  clearErrors?: any;
};

export type PeriodicityProps = {
  periodicityLength: number;
  control: any;
  client: any;
  getValues: any;
  setValue: any;
  renderLess?: boolean;
};

export type AssociateAgentWithContactModalProps = {
  contact: any;
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
};

export type ContactsListProps = {
  shouldUpdate: boolean;
  setShouldUpdate: any;
  url: string;
  websocketEventName: string;
};

export type WYSIWYGEditorProps = {
  value: any;
  toolbar: any;
  mention?: any;
  hashtag?: any;
  onChange?: (value: any) => void;
  readOnly?: boolean;
  formRef?: any;
  reset?: boolean;
  classOverride?: any;
  id?: string;
  className?: string;
  allowNewLine?: boolean;
};

export type ClientFormProps = {
  selectedClient?: ClientModel | any;
  onClose?: any;
  handleContentChange?: (openCompany?: boolean) => void;
  onSuccess?: any;
};

export type BillingDocClientDataProps = {
  register: any;
  formState: any;
  clientData?: any;
};

export type TabPanelProps = {
  children: ReactNode;
  value: number;
  index: number;
  style?: any;
  className?: string;
};

export type StatusPanelType = {
  selectedOption?: object | any;
  handleChange?: void | any;
  allOptions?: object[] | any;
  disabled?: boolean;
};

export type AddOrderStatusModalProps = {
  openAddOrderStatusModal: boolean;
  handleChangeOrderStatusModalValue: () => void;
  selectedRow: any;
  sortNumber: number;
  getOrderStatus: () => void;
};

export type DeleteOrderStatusProps = {
  openDeleteModal: boolean;
  setOpenDeleteModal: (openDeleteModal: boolean) => void;
  handleDelete: () => void;
};

export type ImageGalleryProps = {
  images: any[];
};

export type AdditionalDataProps = {
  openMenu: boolean;
  anchorEl: any;
  handleClose: (tag: any) => void;
  handleClick: (event: any) => void;
};

export type EmailTemplateFormProps = {
  onClose?: () => void;
};

export type UserFormProps = {
  selectedUser?: UserModel | any;
  setContextValue?: any;
  onClose?: any;
};

export type LocalRouterProps = {
  routes: any;
  name: string;
};

export type ConnectWithFacebookProps = {
  setShouldUpdate: any;
};

export type WhatsAppMenuProps = {
  whatsAppBusinessAccountData: WhatsAppBusinessAccountData;
};

export type WhatsAppTemplateComponentContainerProps = {
  children: ReactNode;
  name: string;
  isOptional?: boolean;
  otherHeaderComponents?: ReactNode;
};

export type TemplateHeaderComponentProps = {
  methods: any;
};

export type TemplateBodyComponentProps = {
  methods: any;
};

export type ObservationWidgetProps = {
  text: string;
  shouldRenderIcon?: boolean;
  link?: string;
};

export type TemplateButtonComponentProps = {
  methods: any;
};

export type WhatsAppTagManagementComponentProps = {
  methods: any;
  children: ReactNode;
  examplePropertyName: string;
  mainProperty: string;
  maxNrOfTags?: number;
  maxlengthMainString?: number;
};

export type HelperTextProps = {
  errorText: string | undefined;
  textLength: number | undefined;
  maxLength: number | undefined;
};

export type PhoneRegistrationStepType = {
  label: string;
  component: ReactNode;
  formName: string;
};

export type ChatProps = {
  className?: string | null | undefined;
  id?: string | null;
  disabled?: boolean;
};

export type MessagesListProps = {
  messages: MessageModel[];
  shouldScrollPage: boolean;
  replyToMessage: (message: MessageModel) => void;
  renderMessageContext: (messageId: string | null | undefined) => ReactNode;
  disabled?: boolean;
  key: string;
};

export type ChatTemplatesProps = {
  templates: any[];
  clientId: string | null;
  sendTemplateMessage: (message: any) => void;
  disabled?: boolean;
};

export type WhatsAppTemplatePreviewProps = {
  template: any;
  shouldRenderCurrentDate?: boolean;
};

export type LogProps = {
  log: LogModel;
};

export type FiltersProps = {
  filters: Filter[];
  customFilterModel?: object;
};

export type Filter = {
  property: string;
  label: string;
  type: string;
  validation: any;
  defaultValue: any;
  options?: any;
  autocompleteFilterProperty?: string;
  disableFlag?: boolean;
  controlProperty?: string;
};

export type DirtyFormGuardProps = {
  when: any;
};

export type PreviewDocumentProps = {
  open: boolean;
  title: string;
  onClose: (emailSent: boolean) => void;
  htmlContent: string;
  url?: string;
  customTopMenu?: JSX.Element | null | undefined;
};

export type FilePreviewProps = {
  file: any;
  setFile: (file: any) => void;
  phone: string;
  conversationId: string | null | undefined;
  className?: string | null | undefined;
};

export type MessagesAttachmentsProps = {
  setFile: (file: any) => void;
};

export type ChatOptionsProps = {
  chat: ConversationModel;
  handleDeleteConversation: () => void;
  updateConversationState: (conversation: ConversationModel) => void;
};

export type ClientsAutocompleteProps = {
  formId: string;
  submitAction: (data: any) => void;
};

export type SearchComponentProps = {
  searchParamName?: string;
};

export type OptionSelectorProps = {
  questionText: string;
  selectedOption: string;
  options: string[]; // Array of options
  valueRadio: string;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    selectedValue: string
  ) => void;
};

export type DropDownButtonProps = {
  children?: any;
  action?: (event: any) => void;
};

export type ClientCategoryManagementProps = {
  handleContentChange: () => void;
};

export type ClientGeneralInfoProps = {
  client: ClientModel | undefined;
  setClient: (client: ClientModel) => void;
};

export type NewTaskButtonProps = {
  style?: string;
};

export type TaskProps = {
  advancedOptions?: boolean;
  name: string;
};

export type PropertyContainerProps = {
  property: string;
  propertyInput: any;
  propertyIcon?: any;
};

export type AlertsProps = {
  id: string;
  model: object;
  modelType: string;
  excludedFields: string[];
};

export type TaskPeriodicityProps = {
  getValues: UseFormGetValues<any>;
  watch: UseFormWatch<any>;
  control: Control<any, any>;
  setValue: UseFormSetValue<any>;
  setOpenPeriodicity: (value: boolean) => void;
  periodicities: any[];
};

export type ApprovalModalProps = {
  openModal: boolean;
  handleClose: () => void;
  handleApproveAction: () => void;
  message?: string;
};

export type SubtasksModalProps = {
  open: boolean;
  onClose: () => void;
  statuses: TaskStatusModel[] | [];
  parentTaskId: string | null;
  isParentFinished: boolean;
};

export type FileExplorerMinProps = {
  id?: any;
  name: string;
  deleteUrl?: string;
  shouldCRUDFile?: boolean;
  baseFolderPath?: string;
  files?: any[];
  componentTextDescription?: string;
};

export type AlertDrawerProps = {
  editAlert: AlertModel | null;
  open: boolean;
  propertyOptions: string[];
  ruleOptions: { label: string; value: string; }[];
  addOrUpdateAlert: (alert: AlertModel) => void;
  onClose: () => void;
};

export type OneAlertProps = {
  propertyOptions: string[];
  ruleOptions: { label: string; value: string; }[];
  onClose: () => void;
};

export type FilterConfiguratorProps = {
  model: any;
};

export type ContractData = {
  contractDate: string;
  providerCompany: string;
  providerAddress: string;
  providerCUI: string;
  providerJ: string;
  providerRepresentative: string;
  clientName: string;
  clientAddress: string;
  clientCNP: string;
};

export type StatusItem = {
  _id: string;
  name: string;
  label: string;
  color: string;
};
